import { createContext, useContext } from "react";
import type { Project, Slide } from "@makeit/schema";

export interface SlideResult {
  slideId: number;
  correct: boolean;
  points: number;
  /** 0–3, games only */
  stars: number;
  /** PlayerManager.errors for the page (the classroom game score is made from them) */
  errors?: number;
  answer?: string;
}

export interface PlayerContextValue {
  project: Project;
  slide: Slide;
  slideIndex: number;
  slideCount: number;
  /** Date.now() when the current slide was shown (for timed quiz points). */
  slideStartedAt: number;
  /** Quiz with timer: the time for the current slide ran out (Timer.cs → TimeFinished). */
  timeUp: boolean;
  /** Called by an activity when it is finished. */
  finish: (result: Omit<SlideResult, "slideId">) => void;
  /** Jump to a slide by index in play order (free-element links). */
  goToSlide: (slideIndex: number) => void;
  next: () => void;
  prev: () => void;
}

export const PlayerContext = createContext<PlayerContextValue | null>(null);

export function usePlayer(): PlayerContextValue {
  const ctx = useContext(PlayerContext);
  if (!ctx) throw new Error("usePlayer() outside of a Player");
  return ctx;
}
